import { initializeChakraComponent } from 'Shared/chakra-initialize';
import { OptionsDisplay, CommunityPageType } from './options';

const CommunityOptions = ({ images, lang, optionLinks, eventsEnabled }) => (
   <OptionsDisplay
      images={images}
      lang={lang}
      links={optionLinks}
      page={CommunityPageType.PARTICIPATION}
      eventsEnabled={eventsEnabled}
   />
);

initializeChakraComponent('CommunityOptions', CommunityOptions);
